import React from 'react';
import aboutImg1 from '../images/about1.jpg';
import aboutImg2 from '../images/about2.jpg';
import aboutImg3 from '../images/about3.jpg';
import aboutImg4 from '../images/logo6.png';
import logo4 from '../images/logo4.jpg';
import logo5 from '../images/logo5.jpg';

const featuresData = [
  {
    id: 1,
    icon: "⏱️",
    image: aboutImg1,
    title: "5+ Years Experience",
    description: "We have 5 year experience in a large manufacturing company from logistics to processing and distribution departments and most agriculture businesses and many more"
  },
  {
    id: 2,
    icon: "🎓",
    image: aboutImg4,
    isLogo: true,
    title: "NEBOSH Certified",
    description: "Nebosh certified professionals ensuring the highest standards of safety consultation"
  },
  {
    id: 3,
    icon: "💬",
    image: aboutImg2,
    title: "Competent Consultation",
    description: "We offer Competent advise with zoom conference calls one on one. No business is small or large, Feel free to call for a quote with no obligations"
  },
  {
    id: 4,
    icon: "📋",
    image: aboutImg3,
    title: "Risk Assessment Reviews",
    description: "Legal, moral and financial Risk assessment reviews"
  }
];

const guidesData = [
  {
    id: 1,
    icon: "⚠️",
    image: logo4,
    title: "COSHH Symbols Guide",
    description: "Understanding workplace safety symbols and their meanings"
  },
  {
    id: 2,
    icon: "🚧",
    image: logo5,
    title: "Safety Warning Signs",
    description: "Comprehensive safety signage for workplace protection"
  }
];

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="section-header">
          <div className="section-badge">About Us</div>
          <h2 className="section-title">Creating Safer Work Environments</h2>
        </div>

        <div className="about-intro">
          <div className="about-text">
            <p className="about-description">
              We aim to have a better and safer environment for employees and employers for any type of businesses. 
              We also offer better culture and more benefits to organisations with implementing Health and Safety within 
              their business structure. We are competent, certified professionals Chartered And members of IOSH.
            </p>
            <p className="about-description">
              We have 5 year experience in a large manufacturing company from logistics to processing and distribution 
              departments and most agricultural businesses and many more. We offer Competent advise with zoom conference 
              calls One on ones. No business is small or large. Feel free to call for a quote with no obligations. 
              Legal, moral and financial Risk assessment reviews.
            </p>
          </div>
        </div>

        <div className="features-grid">
          {featuresData.map((feature) => (
            <div key={feature.id} className={`feature-card ${feature.isLogo ? 'feature-card-logo' : ''}`}>
              <div className="feature-image-container">
                <img src={feature.image} alt={feature.title} className="feature-image" />
              </div>
              <div className="feature-content">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="guides-section">
          <h3 className="guides-title">Resources & Guides</h3>
          <div className="guides-grid">
            {guidesData.map((guide) => (
              <div key={guide.id} className="guide-card">
                <div className="guide-image-container">
                  <img src={guide.image} alt={guide.title} className="guide-image" />
                </div>
                <div className="guide-content">
                  <div className="guide-icon">{guide.icon}</div>
                  <h4 className="guide-title">{guide.title}</h4>
                  <p className="guide-description">{guide.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
